import { AppMultiSelect, AppRemixIcon } from "@/layout/AppComponents";
import errorHandler from "@/layout/components/error/ErrorHandler";
import axios from "axios";
import { useCallback, useEffect, useState } from "react";
import ReactDOMServer from "react-dom/server";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { axiosPath } from "../../../../routing/helpers/router";
import Translator from "../../helpers/Translator";
import useIsMounted from "../../hooks/useIsMounted";

export default function ObligationAssociationSelect(props) {
  const {
    value,
    onHandleChange,
    className = "mb-2",
    isMulti = true,
    allowSelectAll = true,
    hasSearchBox = false,
    hasSelectOptions = false,
  } = props;
  const { moduleBridgeHex, plantHex } = useParams();
  const dispatch = useDispatch();
  const isMounted = useIsMounted();
  const [obligationAssociations, setObligationAssociations] = useState();

  // > LOAD OBLIGATION ASSOCIATIONS
  const loadObligationAssociations = useCallback(
    async () =>
      axios
        .post(
          axiosPath(
            plantHex
              ? "api_r_user_module_legalCompliance_evaluation_getObligationAssociations"
              : "api_r_user_module_globalLegalCompliance_evaluation_getObligationAssociations"
          ),
          { moduleBridgeHex, plantHex }
        )
        .then((r) => {
          if (isMounted.current) {
            setObligationAssociations(r.data);
          }
        })
        .catch((e) => dispatch(errorHandler(e))),

    [moduleBridgeHex, plantHex]
  );

  useEffect(() => {
    loadObligationAssociations();
  }, []);
  // < LOAD OBLIGATION ASSOCIATIONS //

  return (
    <AppMultiSelect
      options={obligationAssociations}
      title={ReactDOMServer.renderToString(
        <Translator
          file="module-legalCompliance"
          name="legal-compliance.filter.group.note"
        />
      )}
      placeholder={ReactDOMServer.renderToString(
        <Translator
          file="module-legalCompliance"
          name="legal-compliance.select.one.or.multiple.group.notes"
        />
      )}
      value={value}
      onChange={(opt) => onHandleChange(opt)}
      isMulti={isMulti}
      icon={<AppRemixIcon icon="apps-2" />}
      allowSelectAll
      isLoading={!obligationAssociations}
      hasSearchBox={hasSearchBox}
      hasSelectOptions={hasSelectOptions}
    />
  );
}
